(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping-calculator"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  // ---------- utils ----------
  const norm = (s) => (s || '')
    .toString().trim().toLowerCase()
    .normalize('NFKD').replace(/[\u0300-\u036f]/g, '') // accents
    .replace(/[^\p{L}\p{N}\s-]/gu, '')                 // emoji/symbols
    .replace(/\s+/g, ' ');

  // light fuzzy: one edit or adjacent swap
  function isOneEditAway(a, b) {
    const la = a.length, lb = b.length;
    if (Math.abs(la - lb) > 1) return false;
    if (la === lb) {
      let diff = 0, swap = false;
      for (let i = 0; i < la; i++) {
        if (a[i] !== b[i]) {
          diff++;
          if (i + 1 < la && a[i] === b[i+1] && a[i+1] === b[i]) swap = true;
          if (diff > 2) return false;
        }
      }
      return diff <= 1 || swap;
    }
    let i = 0, j = 0, edits = 0;
    while (i < la && j < lb) {
      if (a[i] === b[j]) { i++; j++; }
      else { edits++; if (edits > 1) return false; (la > lb) ? i++ : j++; }
    }
    return true;
  }

  // ---------- scope ----------
  const root   = document.querySelector('[data-hook="sf-root"]');
  if (!root) return;
  const input  = root.querySelector('[data-hook="sf-input"]');
  const list   = root.querySelector('[data-hook="sf-suggestions"]');
  const form   = root.querySelector('.bs-sf__form');
  const errorEl= root.querySelector('.bs-sf__error');
  const rowsEls= Array.from(root.querySelectorAll('.bs-sf__country'));

  // ---------- countries + aliases ----------
  const countries = rowsEls.map(el => {
    const key  = el.getAttribute('data-index');
    const name = el.getAttribute('data-name') || key.replace(/-/g, ' ');
    return { key, name, nameNorm: norm(name) };
  });

  const aliasBuckets = {
    'australia': ['au','aus','australia'],
    'united-states': ['us','usa','u.s.','u.s.a.','america','united states','united states of america'],
    'united-kingdom': ['uk','u.k.','gb','great britain','britain','england','united kingdom'],
    'united-arab-emirates': ['uae','u.a.e.','united arab emirates'],
    'new-zealand': ['nz','n.z.','new zealand'],
    'south-korea': ['korea','republic of korea','south korea'],
  };

  const aliasMap = new Map();
  const displayNameByKey = new Map();
  countries.forEach(c => {
    displayNameByKey.set(c.key, c.name);
    const bucket = aliasBuckets[c.key];
    if (bucket) bucket.forEach(a => aliasMap.set(norm(a), { key: c.key, name: c.name }));
    aliasMap.set(c.nameNorm, { key: c.key, name: c.name });
  });

  // ---------- helpers ----------
  function showCountryByKey(key) {
    rowsEls.forEach(el => el.style.display = 'none');
    if (!key) return;
    const el = root.querySelector(`.bs-sf__country[data-index="${key}"]`);
    if (el) el.style.display = '';
  }

  function setHash(val) {
    const url = new URL(window.location.href);
    if (val) url.hash = 'ship=' + encodeURIComponent(val);
    else if (url.hash.startsWith('#ship=')) url.hash = '';
    history.replaceState(null, '', url);
  }

  function updateError(q, hasSuggestions) {
    errorEl.style.display = (!hasSuggestions && q.trim().length >= 2) ? '' : 'none';
  }

  function clearSuggestions() {
    list.innerHTML = '';
    list.style.display = 'none';
    form.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-activedescendant', '');
    activeIndex = -1;
  }

  function highlight(label, q) {
    const nLabel = norm(label), nQ = norm(q);
    if (!nQ) return label;
    const idx = nLabel.indexOf(nQ);
    if (idx === -1) return label;
    return label.substring(0, idx) + '<b>' +
           label.substring(idx, idx + nQ.length) + '</b>' +
           label.substring(idx + nQ.length);
  }

  function scoreCandidate(q, cand) {
    const qn = norm(q), cn = cand.nameNorm;
    if (cn.startsWith(qn)) return 0;
    if (cn.split(' ').some(w => w.startsWith(qn))) return 1;
    if (isOneEditAway(cn, qn) || isOneEditAway(qn, cn)) return 2;
    for (const [aliasNorm, rec] of aliasMap.entries()) {
      if (rec.key !== cand.key) continue;
      if (aliasNorm.startsWith(qn)) return 1;
      if (isOneEditAway(aliasNorm, qn) || isOneEditAway(qn, aliasNorm)) return 2;
    }
    return 99;
  }

  // ---------- suggestions (NO auto-complete) ----------
  let activeIndex = -1;

  function buildSuggestions(q) {
    const qn = norm(q);
    if (!qn) {
      clearSuggestions();
      updateError('', false);
      showCountryByKey(null);
      return;
    }

    const items = countries
      .map(c => ({ c, score: scoreCandidate(q, c) }))
      .filter(x => x.score < 99)
      .sort((a,b) => a.score - b.score || a.c.name.localeCompare(b.c.name))
      .slice(0, 6);

    list.innerHTML = '';
    items.forEach((item) => {
      const opt = document.createElement('div');
      opt.className = 'bs-sf__option';
      opt.setAttribute('role', 'option');
      opt.setAttribute('data-key', item.c.key);
      opt.setAttribute('data-name', item.c.name);
      opt.innerHTML = highlight(item.c.name, q);
      list.appendChild(opt);
    });

    if (items.length) {
      list.style.display = 'block';      // <-- force visible
      form.setAttribute('aria-expanded', 'true');
      activeIndex = -1;
    } else {
      clearSuggestions();
    }

    showCountryByKey(null);
    updateError(q, items.length > 0);
  }

  function choose(index) {
    const opts = Array.from(list.querySelectorAll('.bs-sf__option'));
    if (!opts.length) return;
    const opt  = opts[Math.max(0, Math.min(index, opts.length - 1))];
    const key  = opt.getAttribute('data-key');
    const name = opt.getAttribute('data-name');
    input.value = name;
    setHash(name);
    showCountryByKey(key);
    clearSuggestions();
    updateError(name, true);
  }

  // ---------- events ----------
  input.addEventListener('input', (e) => {
    buildSuggestions(e.target.value);
  });

  // Prevent ANY native submit (stops the '?')
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const opts = Array.from(list.querySelectorAll('.bs-sf__option'));
    if (opts.length) {
      // If user hits Enter without arrowing, pick the first suggestion
      choose(activeIndex >= 0 ? activeIndex : 0);
    } else {
      // No suggestions -> keep error visible, do nothing else
      updateError(input.value, false);
    }
  });

  // keyboard nav + Enter selection
  input.addEventListener('keydown', (e) => {
    const opts = Array.from(list.querySelectorAll('.bs-sf__option'));

    if (e.key === 'Enter') {
      e.preventDefault(); // always stop form submit
      if (opts.length) choose(activeIndex >= 0 ? activeIndex : 0);
      else updateError(input.value, false);
      return;
    }
    if (!opts.length) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      activeIndex = (activeIndex + 1) % opts.length;
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      activeIndex = (activeIndex - 1 + opts.length) % opts.length;
    } else if (e.key === 'Escape') {
      clearSuggestions();
    }

    opts.forEach((el,i)=> el.classList.toggle('is-active', i === activeIndex));
    if (opts[activeIndex]) input.setAttribute('aria-activedescendant', opts[activeIndex].getAttribute('data-key'));
  });

  list.addEventListener('click', (e) => {
    const opt = e.target.closest('.bs-sf__option');
    if (!opt) return;
    const idx = Array.from(list.children).indexOf(opt);
    choose(idx);
  });

  input.addEventListener('blur', () => setTimeout(clearSuggestions, 150));

  // hydrate from #ship=… on load
  if (window.location.hash.startsWith('#ship=')) {
    const initial = decodeURIComponent(window.location.hash.slice(6));
    input.value = initial;
    const hit = aliasMap.get(norm(initial));
    if (hit) showCountryByKey(hit.key);
  }
});

  } catch(e) { console.error(e); }
})();
})();
